import { type ReactNode } from 'react'
import { Link } from 'react-router-dom'

interface Props {
  feature: string
  requiredPlan: string
  children: ReactNode
  hasAccess: boolean
}

export function PlanGate({ feature, requiredPlan, children, hasAccess }: Props) {
  if (hasAccess) return <>{children}</>

  return (
    <div className="text-center py-16 bg-white dark:bg-[#1c2230] rounded-xl border border-[#e7ebf3] dark:border-white/10">
      <span className="material-symbols-outlined text-5xl text-[#1754cf] mb-4 block">lock</span>
      <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
        {feature} requires {requiredPlan} plan
      </h3>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-6 max-w-sm mx-auto">
        Upgrade your plan to unlock {feature.toLowerCase()} and other premium features.
      </p>
      <Link
        to="/pricing"
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#1754cf] text-white text-sm font-medium rounded-lg hover:opacity-90 shadow-[0_4px_14px_0_rgba(23,84,207,0.39)]"
      >
        <span className="material-symbols-outlined text-[18px]">upgrade</span>
        Upgrade Plan
      </Link>
    </div>
  )
}
